import { Component, output, signal } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { ButtonComponent } from 'src/components/button/button.component';
import { IconModule } from 'src/components/icon/icon.module';
import { InputTextComponent } from 'src/components/input/input-text.component';
import { Form, FormError } from 'src/definitions/form.definition';
import { ForgotPinRequestOtpForm } from 'src/definitions/auth.definition';
import { FormService } from 'src/services/form.service';
import { GlobalService } from 'src/services/global.service';
import { RestService } from 'src/services/rest.service';
import { ToastService } from 'src/services/toast.service';

@Component({
  selector: 'step-email',
  templateUrl: './step-email.component.html',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, IconModule, ButtonComponent, InputTextComponent],
})
export class _StepEmailComponent {
  form: Form<ForgotPinRequestOtpForm> = new FormBuilder().nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
  });

  formError: FormError<ForgotPinRequestOtpForm> = {
    label: '',
    msg: '',
    email: { label: 'E-mail', msg: '' },
  };

  formSubmitting = signal<boolean>(false);

  email = signal<string>('');

  toPrev = output<void>();
  toNext = output<string>();

  constructor(
    private restService: RestService,
    private toastService: ToastService,
    protected formService: FormService,
    protected globalService: GlobalService,
  ) {}

  protected async _onSubmit() {
    if (this.formSubmitting()) return;

    const invalid = this.formService.validateAndGetErrorMessage(this.form, this.formError);
    if (invalid) {
      this.globalService.errorHandler(new Error(invalid), 'Gagal meminta kode OTP');
      return;
    }

    try {
      this.formSubmitting.set(true);

      const payload = { ...this.form.getRawValue() };
      await lastValueFrom(this.restService.forgotPinRequestOtp(payload));

      this.toastService.showToast({
        summary: 'Berhasil',
        detail: 'Kode OTP berhasil dikirimkan ke email kamu.',
        severity: 'success',
      });

      this.toNext.emit(payload.email);
    } catch (error) {
      error = this.formService.serverErrorHandler(error, this.formError);
      this.globalService.errorHandler(error, 'Gagal meminta kode OTP');
    } finally {
      this.formSubmitting.set(false);
    }
  }
}
